import { put, select, takeLatest } from "redux-saga/effects";

import { getShippingFail, getShippingSuccess } from "../actions";
import { CMSShippingMethod, GET_SHIPPING_REQUEST, GetShippingRequestAction } from "../types";
import cmsApi from "../../utils/api-helper/cmsApi";
import { CMS_ENVIRONMENT } from "../../utils/constants";

function* getShippingSaga(action: GetShippingRequestAction) {
    try {
        //@ts-ignore
        const res = yield cmsApi.get("/shipping-methods");
        const shippings = (res.data.data as CMSShippingMethod[]).map((shipping) => ({
            id: shipping.id,
            name: shipping.attributes.Name,
            shippingMethod: shipping.attributes.ShippingMethod,
            stripeShippingRateId: CMS_ENVIRONMENT === "prod" ? shipping.attributes.StripeShippingRateId_Prod : shipping.attributes.StripeShippingRateId_Test,
            stripeFreeShippingRateId: CMS_ENVIRONMENT === "prod" ? shipping.attributes.StripeFreeShippingRateId_Prod : shipping.attributes.StripeFreeShippingRateId_Test,
            price: shipping.attributes.Price,
        }));
        yield put(getShippingSuccess(shippings));
    } catch (error) {
        yield put(getShippingFail(error));
    }
}

// for admin

function* saveState() {
    //@ts-ignore
    const state = yield select();
    yield localStorage.setItem("initState", JSON.stringify(state));
}

const sagaWatcher = [takeLatest(GET_SHIPPING_REQUEST, getShippingSaga), takeLatest("*", saveState)];

export default sagaWatcher;
